import DOMPurify from 'dompurify';

// Harden anchors that open a new tab against reverse-tabnabbing.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

// Sanitize admin-authored page HTML before rendering via dangerouslySetInnerHTML.
// Allows common rich-text + media tags/attributes while stripping scripts and event handlers.
export function sanitizeHtml(html) {
  if (!html) return '';
  return DOMPurify.sanitize(String(html), {
    ADD_ATTR: ['target', 'rel'],
    ADD_TAGS: ['iframe'],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
  });
}
